import { cloneDeep } from 'lodash/lang'

const resetWeekReservations = (state, action) => {
  const { weekReservationsForm } = action

  return cloneDeep(weekReservationsForm)
}

export default resetWeekReservations
